import { ButtonHTMLAttributes } from 'react';

interface IAddItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	height?: number;
}

const AddItem = ({ children, onClick, height = 112 }: IAddItemProps) => (
	<button
		type="button"
		className="flex cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-slate-400 text-slate-500 select-none"
		onClick={onClick}
		style={{ height }}
	>
		{children}
	</button>
);

export default AddItem;
